<template>
  <div class="record">
    <div class>
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="bdate">手机号:</label>
            <input
              v-model="search.phone"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for="bdate">订单编号:</label>
            <input
              v-model="search.no"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for="bdate">充值时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH::mm:ss"
              v-model="search.chargeTime"
              type="datetimerange"
            ></el-date-picker>
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <template>
        <div class="show-list list-right">
          <el-table
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="充值时间"
              prop="payTime"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="手机号码"
              prop="mobile"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="金额(元)"
              prop="rechargeAmount"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="赠送金额"
              prop="giftAmount"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="推荐人"
              prop="referrer"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="操作人"
              prop="operator"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="订单编号"
              prop="no"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="备注"
              prop="remark"
            ></el-table-column>
          </el-table>
          <div class="total-amount">
            <span>金额统计:</span><span>充值金额:</span
            ><span>{{ userTotalAmount.rechargeAmount }}</span
            ><span>赠送金额:</span><span>{{ userTotalAmount.giftAmount }}</span>
          </div>
          <Page v-on:pagination="receivePaginationData"></Page>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getRechargeOrderList, getTotalAmount } from "@/api/url";
import Page from "../../commons/parking/commons/page.vue";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        phone: "",
        no: "",
        chargeTime: "",
      },
      tableListData: [],
      userTotalAmount: {
        giftAmount: 0,
        rechargeAmount: 0,
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getRechargeOrderList(), {
        page: curPage,
        limit: this.search.pageSize,
        phone: this.search.phone,
        no: this.search.no,
        beginTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[0] ? this.search.chargeTime[0] : "" : "",
        endTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[1] ? this.search.chargeTime[1] : "" : "",
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.getPage(pageObj);
        const tempData = data.data.rows;
        this.tableListData = tempData.map((item) => {
          const userInfo = this.isJsonObj(item.userId)
            ? JSON.parse(item.userId)
            : {};
          const referrer = this.isJsonObj(item.referrer)
            ? JSON.parse(item.referrer)
            : {};
          item.referrer = referrer.name;
          item.mobile = userInfo.mobile;
          item.rechargeAmount = Number(item.rechargeAmount).toFixed(2);
          item.giftAmount = Number(item.giftAmount).toFixed(2);
          return item;
        });
      });
    },
    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
      this.getTotalAmount();
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/rechargeOrder/export",
        {
          phone: this.search.phone,
          no: this.search.no,
          beginTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[0] ? this.search.chargeTime[0] : "" : "",
          endTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[1] ? this.search.chargeTime[1] : "" : "",
        },
        "充值记录"
      );
    },
    isJsonObj(obj) {
      try {
        if (
          typeof JSON.parse(obj) === "object" &&
          JSON.parse(obj) &&
          Object.keys(JSON.parse(obj)).length > 0
        ) {
          return true;
        }
      } catch (error) {}

      return false;
    },
    getTotalAmount() {
      const params = {
        beginTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[0] ? this.search.chargeTime[0] : "" : "",
        endTime: Array.isArray(this.search.chargeTime) ? this.search.chargeTime[1] ? this.search.chargeTime[1] : "" : "",
        phone: this.search.phone || "",
        no: this.search.no || "",
      };
      this.$get(getTotalAmount(), params).then((result) => {
        if (result.status === 200) {
          this.userTotalAmount = result.data;
        }
      });
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
    this.getTotalAmount();
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.total-amount {
  text-align: center;
  span {
    display: inline-block;
    box-sizing: border-box;
    padding-right: 10px;
    &:nth-child(2n + 1) {
      color: red;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
<style>
.record .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>

 